// @ngInject
Filters.FormatSmartFieldsFilter = function FormatSmartFieldsFilter() {
    return function(input) {
        if (!input) {
            return '';
        }
        return input.replace(/\{field:([^\}]+)\}/g, function(match, fieldName) {
            var processedName = fieldName.replace(/[._]/g, ' ');
            return '{' + processedName + '}';
        });
    };
}; 
